// extracted by mini-css-extract-plugin
export var md = "_1x-4";
export var semantic = "_1x-5";
export var sm = "_1x-3";
export var text = "_1x-6";
export var toggleInput = "_1x-0";
export var toggleSwitch = "_1x-1";
export var xs = "_1x-2";